import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useDocumentMeta from '../../utils/useDocumentMeta';
import PublicNavbar from '../../components/PublicNavbar/PublicNavbar';
import './GetStartedPage.css';

const GetStartedPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    useDocumentMeta('seo-getstarted-title', 'seo-getstarted-desc', { canonicalPath: '/get-started' });

    return (
        <>
        <PublicNavbar />
        <div className="gsp">

            {/* ── Main ── */}
            <main className="gsp-main">

                {/* Hero image */}
                <div className="gsp-hero-wrapper">
                    <div
                        className="gsp-hero-image"
                        style={{ backgroundImage: `url("/images/GetStarted/hero.png")` }}
                    />
                </div>

                {/* Heading */}
                <div className="gsp-heading">
                    <h1 className="gsp-title">{t('gsp-title')}</h1>
                    <p className="gsp-subtitle">{t('gsp-subtitle')}</p>
                </div>

                {/* Cards */}
                <div className="gsp-cards">

                    {/* New user */}
                    <div className="gsp-card">
                        <div
                            className="gsp-card-image"
                            style={{ backgroundImage: `url("/images/GetStarted/register.png")` }}
                        />
                        <div className="gsp-card-body">
                            <p className="gsp-card-title">{t('gsp-new-user-title')}</p>
                            <div className="gsp-card-row">
                                <p className="gsp-card-desc">{t('gsp-new-user-desc')}</p>
                                <button
                                    className="gsp-btn gsp-btn--primary"
                                    onClick={() => navigate('/register')}
                                >
                                    {t('gsp-sign-up')}
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Existing user */}
                    <div className="gsp-card">
                        <div
                            className="gsp-card-image"
                            style={{ backgroundImage: `url("/images/GetStarted/login.png")` }}
                        />
                        <div className="gsp-card-body">
                            <p className="gsp-card-title">{t('gsp-existing-user-title')}</p>
                            <div className="gsp-card-row">
                                <p className="gsp-card-desc">{t('gsp-existing-user-desc')}</p>
                                <button
                                    className="gsp-btn gsp-btn--secondary"
                                    onClick={() => navigate('/login')}
                                >
                                    {t('gsp-sign-in')}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Footer */}
                <footer className="gsp-footer">
                    <p>{t('gsp-footer')}</p>
                </footer>

            </main>

        </div>
        </>
    );
};

export default GetStartedPage;